import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Jumbotron from "../components/jumbotron"
import ImageLeft from "../components/sections/imageLeft"
import ImageRight from "../components/sections/imageRight"
import Divider from "../components/sections/divider"
import Features from "../components/sections/features"
// import RealogyDisclaimer from "../components/sections/realogyDisclaimer"
// import Testimonials from "../components/sections/testimonials"
// import Pricing from "../components/sections/pricing"

const IndexPage = ({ data }) => (
  <Layout>
    <SEO title="Default" />
    <Jumbotron fluid background={data.file.childImageSharp.fluid.src} />
    <Features />
    <Divider />

    <ImageLeft
      image="https://placehold.it/400x300.jpg"
      title="Image Left title
"
      content="Lorem ipsum, dolor sit amet consectetur adipisicing elit. Dolores eius harum minima, aliquid adipisci corporis totam id distinctio quo minus consectetur molestiae nobis natus ea atque, impedit omnis odit exercitationem?

"
    />
    <Divider />
    <ImageRight
      image="https://placehold.it/400x300.jpg"
      title="Image Right title
"
      content="Lorem ipsum, dolor sit amet consectetur adipisicing elit. Dolores eius harum minima, aliquid adipisci corporis totam id distinctio quo minus consectetur molestiae nobis natus ea atque, impedit omnis odit exercitationem?

"
    />
    {/* <Divider />

    <Pricing /> */}
    {/* <Divider />

    <Testimonials /> */}
    {/* <RealogyDisclaimer /> */}
  </Layout>
)

export default IndexPage

export const query = graphql`
  query IndexQuery {
    file(relativePath: { eq: "background.jpg" }) {
      id
      childImageSharp {
        fluid(maxWidth: 1920, maxHeight: 1080, quality: 90) {
          src
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`
